module.exports = __webpack_public_path__ + "static/media/flooring_lcs_60yd_y.e7d78e30.csv";